import { DocsCallout, DocsSteps } from "../components"

Campaigns are shown as channel rows under each segment. A channel row represents the provider,
campaign type, budget cap, launch state, sync state, and provider receipts for that segment.

<DocsSteps>
  <li>Set a budget cap for the channel.</li>
  <li>Launch channels that do not yet exist at the provider.</li>
  <li>Use sync for launched channels when assets, settings, or mappings change.</li>
  <li>Pause or resume channels without deleting provider history.</li>
</DocsSteps>

<DocsCallout title="No user-visible drafts">
  Launch builds provider input from current segment assets, selected channel settings, budget cap,
  provider account, and conversion mappings. The snapshot is internal channel state, not a user
  object to manage.
</DocsCallout>
